export class User {
    public screenname: string = '';
    public firstname: string = '';
    public lastname: string = '';
    public fullname: string = '';
    public is_searchable: boolean = false;

    //Demographic form
    public optional_race_id: string = '';
    public gender: string = '';
    public birthdate: any = '';

    //Lifestyle form
    public optional_education_id: string = '';
    public optional_income_id: string = '';
    public marital_status: string = '';
    public has_children: string = '';

    //Billing profile
    public cardholder_name: string = '';
    public address1: string = '';
    public town_city: string = '';
    public state_region: string = '';
    public country: string = '';
    public postalcode: string = '';
    public status: string = '0';
    public bio: string = '';
    public avatar: string = '';

    // Notification setting
    public notification_type:string='';
    public notifications_frequency:string='';
    public notifications:any=[];
}



// WEBPACK FOOTER //
// ./src/models/user.ts